import {ReactNode, useState} from 'react';
import Accordion from 'react-bootstrap/Accordion';
import styled from 'styled-components';

import {getTheme} from "../shared/themeUtils";

const AccordionWrap = styled.div`
  .accordion-item {
    border: none;
    border-bottom: 1px solid ${getTheme("colors.border")};
  }

  .header-title {
    font-weight: bold;
  }

  .accordion-button {
    transition: none;

    &:focus {
      border: none;
      box-shadow: none;
    }

    &:not(.collapsed) {
      background-color: ${getTheme("accent")};
      color: ${getTheme("colors.primary")};

      &:focus {
        border-bottom: 1px solid ${getTheme("colors.border")};
      }

      &::after {
        background-image: url("/client-images/arrow-black.svg");
      }
    }
  }
`;


interface AccordionSectionProps {
  id: string,
  title: string,
  children?: ReactNode,
  className?: string
}

const AccordionSection = (props: AccordionSectionProps) => {
  const { id, title, children } = props;
  
  // Use defaultActiveKey instead of state for better SSR hydration
  return(
    <AccordionWrap className={props.className}>
      <Accordion defaultActiveKey={null}>
        <Accordion.Item eventKey={id}>
          <Accordion.Header>
            <div className="header-title">{title || ""}</div>
          </Accordion.Header>
          <Accordion.Body>
            {children}
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>   
    </AccordionWrap>
       
  )
}

export default AccordionSection;
